import { useTranslation } from "react-i18next";

export default function SunoImportRecovery({
  failure,
  onUpload,
  onRetry,
  busy = false,
}: {
  failure: { url: string; message: string };
  onUpload: () => void;
  onRetry: () => void;
  busy?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      className="my-3 rounded-xl border border-amber-500/40 bg-amber-500/10 p-4 text-sm"
    >
      <p className="font-semibold">
        {t("sunoRecovery.title", {
          defaultValue: "Upload your song to continue",
        })}
      </p>
      <p className="mt-1">{failure.message}</p>
      <p className="mt-2">
        {t("sunoRecovery.body", {
          defaultValue:
            "Open your song in Suno, download the audio, then upload the MP3, WAV or M4A here. Your prompt and settings stay in place.",
        })}
      </p>
      <div className="mt-3 flex flex-wrap items-center gap-3">
        <button
          type="button"
          disabled={busy}
          onClick={onUpload}
          className="rounded-lg bg-violet-600 px-4 py-2 font-semibold text-white disabled:opacity-50"
        >
          {t("sunoRecovery.upload", { defaultValue: "Upload audio file" })}
        </button>
        <a
          href={failure.url}
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          {t("sunoRecovery.open", { defaultValue: "Open in Suno" })}
        </a>
        <button
          type="button"
          disabled={busy}
          onClick={onRetry}
          className="underline disabled:opacity-50"
        >
          {t("sunoRecovery.retry", { defaultValue: "Try link again" })}
        </button>
      </div>
    </div>
  );
}
